/**
 * Kill switch for showing the user's WhatsApp Ask AICA chats on the web.
 * Flip to `false` and deploy: nothing calls babler and no WhatsApp UI renders.
 * Read it only through `isWhatsAppChatOnWebEnabled()` so tests can mock the accessor.
 */
export const WHATSAPP_CHAT_ON_WEB_ENABLED = true;

export const isWhatsAppChatOnWebEnabled = (): boolean => WHATSAPP_CHAT_ON_WEB_ENABLED;

/** Sidebar row ids for WhatsApp chats are namespaced so they can never collide with an Athena conversation id. */
export const WA_ROW_ID_PREFIX = 'wa:';

export const WHATSAPP_TAG_LABEL = 'WhatsApp';
export const WHATSAPP_READ_ONLY_NOTICE = 'This conversation happened on WhatsApp. Reply to Meera on WhatsApp to continue.';
export const WHATSAPP_LOAD_ERROR_COPY = "Couldn't load this WhatsApp chat";
export const WHATSAPP_OLDER_ERROR_COPY = "Couldn't load older messages";
export const WHATSAPP_RETRY_COPY = 'Retry';
export const WHATSAPP_PERSON_LABEL = 'You';
export const WHATSAPP_MEERA_LABEL = 'Meera';
export const WHATSAPP_LOADING_COPY = 'Loading messages…';
export const WHATSAPP_LOAD_OLDER_COPY = 'Load older messages';
export const WHATSAPP_FILE_ICON = '📄';

export const WHATSAPP_TIMELINE_PAGE_SIZE = 30;

export const WHATSAPP_ENDPOINTS = {
    CHATS: '/bot/wa/chats',
    timeline: (chatId: string) => `/bot/wa/chats/${encodeURIComponent(chatId)}/timeline`,
} as const;

/** babler's `responseData.responseCode` for success. */
export const BABLER_SUCCESS_CODE = 20;

export const WHATSAPP_ITEM_KIND = {
    IN: 'in',
    OUT: 'out',
    FILE: 'file',
} as const;

/** Distance from the top (px) at which scrolling up fetches the next older page. */
export const LOAD_OLDER_SCROLL_THRESHOLD = 40;

/** WhatsApp's triple-backtick code fence. */
export const FENCE = '```';

/** babler answers HTTP 404 on this path when it predates the WhatsApp history endpoints. */
export const HTTP_NOT_FOUND = 404;
